'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var slugifier = function slugifier(text) {
    if (text && typeof text === 'string') {
        return text.toLowerCase().replace(/\|/g, '') // remove pipe
        .replace(/^\s+|\s+$/g, '') // trim leading/trailing spaces
        .replace(/[ ./\\-]+/g, '-') // replace spaces, slashes and backslashes
        .replace(/[¬`!"£$%^&*()[\]{}~@:#';,?:]+/g, '') // remove special chars
        .replace(/[<>"` {}|\\^\n\r\t]/g, encodeURI);
    }
    return undefined;
};

exports.default = slugifier;